export default "__VITE_ASSET__DiMAnn94__"